"use strict";

exports.__esModule = true;
exports.computedValues = void 0;

/* eslint-disable no-undef */
const computedValues = () => {
  const consentStatus = window.gdprConsents || {};
  const consentProps = {
    consentcookies: consentStatus.cookies !== undefined ? consentStatus.cookies : undefined,
    consentselectbasicads: consentStatus.selectBasicAds !== undefined ? consentStatus.selectBasicAds : undefined,
    consentcreateadsprofile: consentStatus.createAdsProfile !== undefined ? consentStatus.createAdsProfile : undefined,
    consentselectpersonalizedads: consentStatus.selectPersonalizedAds !== undefined ? consentStatus.selectPersonalizedAds : undefined,
    consentmeasureadperformance: consentStatus.measureAdPerformance !== undefined ? consentStatus.measureAdPerformance : undefined,
    consentmeasurecontentperformance: consentStatus.measureContentPerformance !== undefined ? consentStatus.measureContentPerformance : undefined,
    consentmarketresearch: consentStatus.marketResearch !== undefined ? consentStatus.marketResearch : undefined,
    consentimproveproducts: consentStatus.improveProducts !== undefined ? consentStatus.improveProducts : undefined,
    consentcreatecontentprofile: consentStatus.createContentProfile !== undefined ? consentStatus.createContentProfile : undefined,
    consentselectpersonalizedcontent: consentStatus.selectPersonalizedContent !== undefined ? consentStatus.selectPersonalizedContent : undefined
  };
  return {
    clienttimestamp: new Date().getTime(),
    ...consentProps
  };
};

exports.computedValues = computedValues;